import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-enter-otp',
  templateUrl: './enter-otp.component.html',
  styleUrls: ['./enter-otp.component.css'],
})
export class EnterOtpComponent implements AfterViewInit {
  @Input() label: string = 'Enter OTP';
  @Input() message: string = '';
  @Input() checkMessage: string = '';

  otp: string[] = Array(6).fill('');
  @ViewChild('otpInput0', { static: false })
  otpInput0!: ElementRef<HTMLInputElement>;
  @ViewChild('otpInput1', { static: false })
  otpInput1!: ElementRef<HTMLInputElement>;
  @ViewChild('otpInput2', { static: false })
  otpInput2!: ElementRef<HTMLInputElement>;
  @ViewChild('otpInput3', { static: false })
  otpInput3!: ElementRef<HTMLInputElement>;
  @ViewChild('otpInput4', { static: false })
  otpInput4!: ElementRef<HTMLInputElement>;
  @ViewChild('otpInput5', { static: false })
  otpInput5!: ElementRef<HTMLInputElement>;

  private inputs: (ElementRef<HTMLInputElement> | undefined)[] = [];

  constructor(public activeModal: NgbActiveModal) {}

  ngAfterViewInit(): void {
    this.inputs = [
      this.otpInput0,
      this.otpInput1,
      this.otpInput2,
      this.otpInput3,
      this.otpInput4,
      this.otpInput5,
    ];
    setTimeout(() => {
      if (this.inputs[0]) {
        this.inputs[0].nativeElement.focus();
      }
    }, 100);
  }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    if (!input.value) {
      return;
    }

    // Keep only last digit
    this.otp[index] = input.value.slice(-1);

    // Move to next input if value entered
    if (input.value && index < 5) {
      const nextInput = this.inputs[index + 1];
      if (nextInput) {
        nextInput.nativeElement.focus();
      }
    }
  }

  onKeyDown(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prevInput = this.inputs[index - 1];
      if (prevInput) {
        prevInput.nativeElement.focus();
      }
    }
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const digits = pastedData.replace(/\D/g, '').slice(0, 6);

    for (let i = 0; i < digits.length && i < 6; i++) {
      this.otp[i] = digits[i];
      const input = this.inputs[i];
      if (input) {
        input.nativeElement.value = digits[i];
      }
    }

    // Focus the next empty input or the last one
    const nextIndex = Math.min(digits.length, 5);
    const nextInput = this.inputs[nextIndex];
    if (nextInput) {
      nextInput.nativeElement.focus();
    }
  }

  confirm(): void {
    const fullOtp = this.otp.join('');
    if (fullOtp.length === 6) {
      this.activeModal.close(fullOtp);
    }
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
